import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Returns true when the current page is being rendered inside the installed
 * PWA (standalone display mode) or when the user landed on the page from a
 * PWA shortcut (`?source=pwa`). Persists the flag in sessionStorage so the
 * whole session (all internal navigations) stays in "app mode".
 */
export function useIsPwaMode() {
  const location = useLocation();
  const [isPwa, setIsPwa] = useState(false);

  useEffect(() => {
    // 1. Native standalone check (Chrome/Android + iOS Safari)
    const standalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    // 2. Session-persistent flag: once we detect PWA, keep it for the session
    const stored = sessionStorage.getItem('pwa_mode') === '1';

    // 3. URL flag from manifest start_url / shortcuts
    const url = new URLSearchParams(location.search);
    const fromShortcut = url.get('source') === 'pwa';

    const detected = standalone || stored || fromShortcut;
    if (detected) {
      sessionStorage.setItem('pwa_mode', '1');
    }
    setIsPwa(detected);
  }, [location.search]);

  return isPwa;
}
